import './MobileMenuItem.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router';

interface MobileMenuItemProps {
  name: string;
  itemKey: string;
  hasChildren: boolean;
  itemClass: string;
  clickHandler: (key: string) => void;
  hreff: string;
  extern: boolean;
  closeEvent: () => void;
  image?: string;
}

export function MobileMenuItem(prop: MobileMenuItemProps) {
  let history = useHistory();

  let className = 'MobileMenuItem';

  if (prop.itemClass != undefined) {
    className = className + ' ' + prop.itemClass;
  }

  return (
    <div
      className={className}
      onClick={() => {
        if (prop.hasChildren) prop.clickHandler(prop.itemKey);
        else {
          prop.closeEvent();
          if (prop.extern) history.push('/extern', prop.hreff);
          else history.push(prop.hreff, null);
        }
      }}
    >
      {prop.image != undefined ? <img src={prop.image} /> : null}
      <label>{prop.name}</label>{' '}
      {prop.hasChildren ? (
        <FontAwesomeIcon
          icon={prop.itemClass == 'menuBack' ? faAngleLeft : faAngleRight}
          className="icon"
        />
      ) : null}
    </div>
  );
}
